import React from "react";
import classes from "./About.module.css";
import { Heading, Text, Button, SectionHeading } from "components/common";
import { useNavigate } from "react-router-dom";

const About = () => {
  const navigate = useNavigate();

  return (
    <div className={classes.aboutPage}>
      {/* Hero Section */}
      <section className={classes.heroSection}>
        <div className={classes.heroContent}>
          <Heading>Building the Future of Investment Together</Heading>
          <Text xl2 primitive0>
            We're revolutionizing the way people invest, making it simpler, smarter, and more accessible for everyone.
          </Text>
          <Button btnPrimary onClick={() => navigate("/sign-up")}>
            Start Investing
          </Button>
        </div>
      </section>

      {/* Brief Section */}
      <section className={classes.briefSection}>
        <div className={classes.briefContent}>
          <Text xl2>
            For over two decades, we've been dedicated to making capital markets accessible to everyone. As asset managers, we work alongside our clients to build a more resilient financial future - not just for today, but for generations to come.
          </Text>
          <Text xl2>
            Our focus is simple: helping our clients reach their financial aspirations.
          </Text>
          <Text xl2>
            When we speak of our achievements, we're really celebrating the trust and success of those who choose to invest with us.
          </Text>
        </div>
      </section>

      {/* Mission Section */}
      <section className={classes.missionSection}>
        <div className={classes.missionContent}>
          <div className={classes.missionText}>
            <Heading xl5>Empowering Investors Worldwide</Heading>
            <Text xl2>
              Our mission is to democratize investment opportunities, providing individuals with the tools and knowledge they need to build wealth and secure their financial future.
            </Text>
          </div>
          <div className={classes.missionStats}>
            <div className={classes.statItem}>
              <Heading xl6>12+</Heading>
              <Text xl>Years of Experience</Text>
            </div>
            <div className={classes.statItem}>
              <Heading xl6>50K+</Heading>
              <Text xl>Active Investors</Text>
            </div>
            <div className={classes.statItem}>
              <Heading xl6>$20M+</Heading>
              <Text xl>Assets Managed</Text>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className={classes.valuesSection}>
        <div className={classes.valuesHeader}>
          <Heading xl5>What We Stand For</Heading>
        </div>
        <div className={classes.valuesGrid}>
          <div className={classes.valueCard}>
            <Heading xl3>Transparency</Heading>
            <Text xl>
              We believe in complete openness about our processes, fees, and investment strategies.
            </Text>
          </div>
          <div className={classes.valueCard}>
            <Heading xl3>Innovation</Heading>
            <Text xl>
              Constantly evolving our platform with cutting-edge technology to serve you better.
            </Text>
          </div>
          <div className={classes.valueCard}>
            <Heading xl3>Security</Heading>
            <Text xl>
              Your investments are protected with industry-leading security measures.
            </Text>
          </div>
          <div className={classes.valueCard}>
            <Heading xl3>Education</Heading>
            <Text xl>
              Empowering investors through comprehensive learning resources and support.
            </Text>
          </div>
        </div>
      </section>

      {/* Team Section */}


      {/* CTA Section */}
      <section className={classes.ctaSection}>
        <div className={classes.ctaContent}>
          <Heading xl5>Ready to Start Your Investment Journey?</Heading>
          <Text xl2>
            Join thousands of successful investors who trust us with their financial future.
          </Text>
          <Button btnPrimary onClick={() => navigate("/sign-up")}>
            Get Started Now
          </Button>
        </div>
      </section>
    </div>
  );
};

export default About;
